/* eslint-disable max-lines-per-function */
import { TranslationService } from '../../../services/translation.service';
import {
	DatacenterDateFilter,
	FilterType,
	DatacenterFreeTextFilter,
	DatacenterNumericFilter,
	FilterApiRequest,
	DropdownFilter,
	DatacenterBooleanFilter,
	GlobalSearchFilter,
} from '../../../models/datacenter-filters';
import { OFFER_SERVER_URL } from '../../../../config';

const GET_PROTOTYPE_SERVER_URL = `${ OFFER_SERVER_URL }/v1/fastlaneItems`;

type FilterTypeFn = () => FilterType;

export class PrototypeFiltersConfiguration {
	constructor(
		private readonly translationService: TranslationService
	) {}

	// eslint-disable-next-line @typescript-eslint/naming-convention
	PROTOTYPE_DATACENTER_FILTERS = () =>
		new Map<string, FilterTypeFn>([
			[
				'customerRequestName',
				() => new DatacenterFreeTextFilter(
					'customerRequestName',
					this.translationService.getTR('datacenter-filter.customer-req-name'),
					this.translationService.getTR('datacenter-filter.customer-req-name'),
					'customerRequestName'
				)
			],
			[
				'soldToDescription',
				() => new DropdownFilter(
					'soldToDescription',
					this.translationService.getTR('datacenter-filter.sold-to'),
					this.translationService.getTR('datacenter-filter.sold-to'),
					'soldTo',
					'soldToDescription',
					new FilterApiRequest(GET_PROTOTYPE_SERVER_URL)
				)
			],
			[
				'thickness',
				() => new DatacenterNumericFilter(
					'thickness',
					this.translationService.getTR('datacenter-filter.thickness'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'thickness'
				)
			],
			[
				'width',
				() => new DatacenterNumericFilter(
					'width',
					this.translationService.getTR('datacenter-filter.width'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'width'
				)
			],
			[
				'supplierRfqNumber',
				() => new DatacenterFreeTextFilter(
					'supplierRfqNumber',
					this.translationService.getTR('application.procurement.supplier.rfqNumber'),
					this.translationService.getTR('application.procurement.supplier.rfqNumber'),
					'supplierRfqNumber'
				)
			],
			[
				'creationDate',
				() => new DatacenterDateFilter(
					'creationDate',
					this.translationService.getTR('order.creation.date'),
					this.translationService.getTR('filter.date.from'),
					this.translationService.getTR('filter.date.to'),
					'creationDate',
					'date'
				)
			],
			[
				'prototypeName',
				() => new DatacenterFreeTextFilter(
					'prototypeName',
					this.translationService.getTR('datacenter-filter.proto-name'),
					this.translationService.getTR('datacenter-filter.proto-name'),
					'prototypeName'
				)
			],
			[
				'requestedSteelGrade',
				() => new DatacenterFreeTextFilter(
					'requestedSteelGrade',
					this.translationService.getTR('datacenter-shipment.grade'),
					this.translationService.getTR('datacenter-shipment.grade'),
					'requestedSteelGrade'
				)
			],
			[
				'formDescription',
				() => new DropdownFilter(
					'formDescription',
					this.translationService.getTR('eoffer.form'),
					this.translationService.getTR('eoffer.form'),
					'form',
					'formDescription',
					new FilterApiRequest(GET_PROTOTYPE_SERVER_URL, { limit: 1500 })
				)
			],
			[
				'requestedDeliveryDate',
				() => new DatacenterDateFilter(
					'requestedDeliveryDate',
					this.translationService.getTR('order.rdd'),
					this.translationService.getTR('filter.date.from'),
					this.translationService.getTR('filter.date.to'),
					'requestedDeliveryDate',
					'date'
				)
			],
			[
				'customerRefusal',
				() => new DatacenterFreeTextFilter(
					'customerRefusal',
					this.translationService.getTR('datacenter-filter.customerRefusal'),
					this.translationService.getTR('datacenter-filter.customerRefusal'),
					'customerRefusal'
				)
			],
			[
				'lastModifiedDate',
				() => new DatacenterDateFilter(
					'lastModifiedDate',
					this.translationService.getTR('datacenter-filter.LMD'),
					this.translationService.getTR('filter.date.from'),
					this.translationService.getTR('filter.date.to'),
					'lastModifiedDate',
					'date'
				)
			],
			[
				'unitWeight',
				() => new DatacenterNumericFilter(
					'unitWeight',
					this.translationService.getTR('fastlane.itemlist.product.blank_weight'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'unitWeight'
				)
			],
			[
				'sheetWeight',
				() => new DatacenterNumericFilter(
					'sheetWeight',
					this.translationService.getTR('fastlane.wizard.items.details.sheet.weight'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'sheetWeight'
				)
			],
			[
				'prototypeDescription',
				() => new DatacenterFreeTextFilter(
					'prototypeDescription',
					this.translationService.getTR('datacenter-filter.additional-desc'),
					this.translationService.getTR('datacenter-filter.additional-desc'),
					'prototypeDescription'
				)
			],
			[
				'coating',
				() => new DatacenterFreeTextFilter(
					'coating',
					this.translationService.getTR('product.title.group.coating'),
					this.translationService.getTR('product.title.group.coating'),
					'coating'
				)
			],
			[
				'innerDiameter',
				() => new DatacenterNumericFilter(
					'innerDiameter',
					this.translationService.getTR('fastlane.itemlist.coil.inner.diameter'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'innerDiameter'
				)
			],
			[
				'length',
				() => new DatacenterNumericFilter(
					'length',
					this.translationService.getTR('batch.length'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'length'
				)
			],
			[
				'outsideDiameter',
				() => new DatacenterNumericFilter(
					'outsideDiameter',
					this.translationService.getTR('need4steel-product-details.max-outside-Diameter'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'outsideDiameter'
				)
			],
			[
				'oiling',
				() => new DatacenterFreeTextFilter(
					'oiling',
					this.translationService.getTR('fastlane.itemlist.productcharacteristic.oilquantity'),
					this.translationService.getTR('fastlane.itemlist.productcharacteristic.oilquantity'),
					'oiling'
				)
			],
			[
				'stockist',
				() => new DatacenterFreeTextFilter(
					'stockist',
					this.translationService.getTR('datacenter-filter.stockist'),
					this.translationService.getTR('datacenter-filter.stockist'),
					'stockist'
				)
			],
			[
				'readyForDispatchWeek',
				() => new DatacenterNumericFilter(
					'readyForDispatchWeek',
					this.translationService.getTR('datacenter-filter.readyForDispatch'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'readyForDispatchWeek'
				)
			],
			[
				'weight',
				() => new DatacenterNumericFilter(
					'weight',
					this.translationService.getTR('datacenter-filter.proposed-weight'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'weight'
				)
			],
			[
				'proposedCoating',
				() => new DatacenterFreeTextFilter(
					'proposedCoating',
					this.translationService.getTR('datacenter-filter.proposed-coating'),
					this.translationService.getTR('datacenter-filter.proposed-coating'),
					'proposedCoating'
				)
			],
			[
				'proposedInnerDiameter',
				() => new DatacenterNumericFilter(
					'proposedInnerDiameter',
					this.translationService.getTR('datacenter-filter.proposed-inner-diameter'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'proposedInnerDiameter'
				)
			],
			[
				'proposedLength',
				() => new DatacenterNumericFilter(
					'proposedLength',
					this.translationService.getTR('datacenter-filter.proposed-length'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'proposedLength'
				)
			],
			[
				'proposedOiling',
				() => new DatacenterFreeTextFilter(
					'proposedOiling',
					this.translationService.getTR('datacenter-filter.proposed-oiling'),
					this.translationService.getTR('datacenter-filter.proposed-oiling'),
					'proposedOiling'
				)
			],
			[
				'proposedOutsideDiameter',
				() => new DatacenterNumericFilter(
					'proposedOutsideDiameter',
					this.translationService.getTR('datacenter-filter.proposed-outside-diameter'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'proposedOutsideDiameter'
				)
			],
			[
				'proposedPackaging',
				() => new DatacenterFreeTextFilter(
					'proposedPackaging',
					this.translationService.getTR('datacenter-filter.proposed-packing'),
					this.translationService.getTR('datacenter-filter.proposed-packing'),
					'proposedPackaging'
				)
			],
			[
				'proposedSteelGrade',
				() => new DatacenterFreeTextFilter(
					'proposedSteelGrade',
					this.translationService.getTR('datacenter-filter.proposed-steelgrade'),
					this.translationService.getTR('datacenter-filter.proposed-steelgrade'),
					'proposedSteelGrade'
				)
			],
			[
				'proposedThickness',
				() => new DatacenterNumericFilter(
					'proposedThickness',
					this.translationService.getTR('datacenter-filter.proposed-thickness'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'proposedThickness'
				)
			],
			[
				'proposedWidth',
				() => new DatacenterNumericFilter(
					'proposedWidth',
					this.translationService.getTR('datacenter-filter.proposed-width'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'proposedWidth'
				)
			],
			[
				'delay',
				() => new DatacenterFreeTextFilter(
					'delay',
					this.translationService.getTR('datacenter-filter.delay'),
					this.translationService.getTR('datacenter-filter.delay'),
					'delay'
				)
			],
			[
				'poNumber',
				() => new DatacenterFreeTextFilter(
					'poNumber',
					this.translationService.getTR('datacenter-filter.ponumber'),
					this.translationService.getTR('datacenter-filter.ponumber'),
					'poNumber'
				)
			],
			[
				'shippingDate',
				() => new DatacenterDateFilter(
					'shippingDate',
					this.translationService.getTR('datacenter-filter.shipping-date'),
					this.translationService.getTR('filter.date.from'),
					this.translationService.getTR('filter.date.to'),
					'shippingDate',
					'date'
				)
			],
			[
				'shippingWeek',
				() => new DatacenterDateFilter(
					'shippingWeek',
					this.translationService.getTR('datacenter-filter.shipping-week'),
					this.translationService.getTR('filter.date.from'),
					this.translationService.getTR('filter.date.to'),
					'shippingWeek',
					'week'
				)
			],
			[
				'transportRef',
				() => new DatacenterFreeTextFilter(
					'transportRef',
					this.translationService.getTR('datacenter-filter.transportRef'),
					this.translationService.getTR('datacenter-filter.transportRef'),
					'transportRef'
				)
			],
			[
				'proposedQuantity',
				() => new DatacenterNumericFilter(
					'proposedQuantity',
					this.translationService.getTR('datacenter-filter.proposed-quantity'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'proposedQuantity'
				)
			],
			[
				'currency',
				() => new DropdownFilter(
					'currency',
					this.translationService.getTR('issue.currency'),
					this.translationService.getTR('issue.currency'),
					'currency',
					'currency',
					new FilterApiRequest(GET_PROTOTYPE_SERVER_URL, { limit: 1500 })
				)
			],
			[
				'coilAxisDescription',
				() => new DropdownFilter(
					'coilAxisDescription',
					this.translationService.getTR('fastlane.itemlist.product.coil_axis'),
					this.translationService.getTR('fastlane.itemlist.product.coil_axis'),
					'coilAxis',
					'coilAxisDescription',
					new FilterApiRequest(GET_PROTOTYPE_SERVER_URL, { limit: 1500 })
				)
			],
			[
				'incoterm',
				() => new DropdownFilter(
					'incoterm',
					this.translationService.getTR('schedule-business-order.incoterm'),
					this.translationService.getTR('schedule-business-order.incoterm'),
					'incoterm',
					'incoterm',
					new FilterApiRequest(GET_PROTOTYPE_SERVER_URL, { limit: 1500 })
				)
			],
			[
				'transportModeDescription',
				() => new DropdownFilter(
					'transportModeDescription',
					this.translationService.getTR('datacenter-filter.transport-mode'),
					this.translationService.getTR('datacenter-filter.transport-mode'),
					'transportMode',
					'transportModeDescription',
					new FilterApiRequest(GET_PROTOTYPE_SERVER_URL, { limit: 1500 })
				)
			],
			[
				'materialAvailabilityDescription',
				() => new DropdownFilter(
					'materialAvailabilityDescription',
					this.translationService.getTR('datacenter-filter.materialAvailability'),
					this.translationService.getTR('datacenter-filter.materialAvailability'),
					'materialAvailability',
					'materialAvailabilityDescription',
					new FilterApiRequest(GET_PROTOTYPE_SERVER_URL, { limit: 1500 })
				)
			],
			[
				'proposedUnitDescription',
				() => new DropdownFilter(
					'proposedUnitDescription',
					this.translationService.getTR('datacenter-filter.proposed-unit'),
					this.translationService.getTR('datacenter-filter.proposed-unit'),
					'proposedUnit',
					'proposedUnitDescription',
					new FilterApiRequest(GET_PROTOTYPE_SERVER_URL, { limit: 1500 })
				)
			],
			[
				'materialNotAvailable',
				() => new DatacenterBooleanFilter(
					'materialNotAvailable',
					this.translationService.getTR('datacenter-filter.material-not-avilable'),
					[
						'TRUE',
						'FALSE'
					],
					['materialNotAvailable'],
					['true', 'false']
				)
			],
			[
				'totalTonnageCalculated',
				() => new DatacenterNumericFilter(
					'totalTonnageCalculated',
					this.translationService.getTR('claim.total.weight'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'totalTonnageCalculated'
				)
			],
			[
				'proposedTonnage',
				() => new DatacenterNumericFilter(
					'proposedTonnage',
					this.translationService.getTR('datacenter-filter.Proposed-Total-weight'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'proposedTonnage'
				)
			],
			[
				'price',
				() => new DatacenterNumericFilter(
					'price',
					this.translationService.getTR('datacenter-filter.Proposed-price'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'price'
				)
			],
			[
				'pricePerUnit',
				() => new DatacenterNumericFilter(
					'pricePerUnit',
					this.translationService.getTR('eoffer.price'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'pricePerUnit'
				)
			],
			[
				'shipToDescription',
				() => new DatacenterFreeTextFilter(
					'shipToDescription',
					this.translationService.getTR('eoffer.shipto'),
					this.translationService.getTR('eoffer.shipto'),
					'shipToDescription'
				)
			],
			[
				'proposedUnitWeight',
				() => new DatacenterNumericFilter(
					'proposedUnitWeight',
					this.translationService.getTR('datacenter-filter.Proposed-blank-weight'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'proposedUnitWeight'
				)
			],
			[
				'poConfirmationReceivedDate',
				() => new DatacenterDateFilter(
					'poConfirmationReceivedDate',
					this.translationService.getTR('datacenter-filter.PO-Reception-date'),
					this.translationService.getTR('filter.date.from'),
					this.translationService.getTR('filter.date.to'),
					'poConfirmationReceivedDate',
					'date'
				)
			],
			[
				'poReceivedWeek',
				() => new DatacenterDateFilter(
					'poReceivedWeek',
					this.translationService.getTR('datacenter-filter.PO-Reception-week'),
					this.translationService.getTR('filter.date.from'),
					this.translationService.getTR('filter.date.to'),
					'poReceivedWeek',
					'week'
				)
			],
			[
				'processingOrderNumber',
				() => new DatacenterFreeTextFilter(
					'processingOrderNumber',
					this.translationService.getTR('datacenter-shipment.supplier-order-number'),
					this.translationService.getTR('datacenter-shipment.supplier-order-number'),
					'processingOrderNumber'
				)
			],
			[
				'priceUnitDescription',
				() => new DropdownFilter(
					'priceUnitDescription',
					this.translationService.getTR('datacenter-filter.price-unit'),
					this.translationService.getTR('datacenter-filter.price-unit'),
					'priceUnit',
					'priceUnitDescription',
					new FilterApiRequest(GET_PROTOTYPE_SERVER_URL, { limit: 1500 })
				)
			],
			[
				'requestedQuantity',
				() => new DatacenterNumericFilter(
					'requestedQuantity',
					this.translationService.getTR('eoffer.quantity'),
					this.translationService.getTR('filter.number.from'),
					this.translationService.getTR('filter.number.to'),
					'requestedQuantity'
				)
			],
			[
				'requestedQuantityUnitDescription',
				() => new DropdownFilter(
					'requestedQuantityUnitDescription',
					this.translationService.getTR('datacenter-filter.quantity-unit'),
					this.translationService.getTR('datacenter-filter.quantity-unit'),
					'requestedQuantityUnit',
					'requestedQuantityUnitDescription',
					new FilterApiRequest(GET_PROTOTYPE_SERVER_URL, { limit: 1500 })
				)
			],
			[
				'globalSearch',
				() => new GlobalSearchFilter(
					'globalSearch',
					this.translationService.getTR('global.search-filter'),
					this.translationService.getTR('global.search-filter'),
					[
						'prototypeName',
						'customerRequestName'
					]
				)
			]
		]);
}
